<template>
  <el-dialog
    center
    width="600px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="选择主播"
        :label-width="formLabelWidth"
        prop="userId"
      >
        <el-select
          v-model="editForm.userId"
          filterable
          remote
          placeholder="请输入主播姓名"
          :remote-method="searchUser"
          clearable
          @clear="editForm.userId = ''"
          :loading="loading"
        >
          <el-option
            v-for="item in userList"
            :key="item.value"
            :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addAnchor } from '@/api/live.js';
import { decrypt } from '@/utils/encryp';
import { getUserModelApi } from '@/api/user.js';
export default {
  data() {
    return {
      userList: [],
      editForm: { userId: '' },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      dialogTitle: '',
      editRules: {
        userId: { required: true, message: '请选择主播', trigger: 'blur' },
      },
      loading: false,
    };
  },
  inject: ['reload'],
  methods: {
    // 处理解密
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    resetFrom() {
      this.editForm = {};
    },
    // 搜索用户名
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.userList = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    // 选择主播下拉选项
    checkServicePerson(val) {
      this.editForm.userId = val;
    },
    async submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('请选择主播!');
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          await addAnchor(this.editForm.userId, areaId).then((res) => {
            if (res.code === 200) {
              this.$message.success('添加成功!');
            }
          });
          this.dialogFormVisible = false;
          this.editForm = {};
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>
